import React from 'react';
import '../csscontainer/InfoBox.css'; // CSS file for styles

function TextBox({
  imageSrc,
  title,
  description,
  bulletPoints,
  showBorder = true,
}) {
  return (
    <div className={`text-box ${showBorder ? "with-border" : "no-border"}`}>
      {/* 1. Dynamic Image: Renders only if imageSrc is provided */}
      {imageSrc && (
        <img src={imageSrc} alt={title || "Visual"} className="text-image" />
      )}

      {/* 2. Dynamic Title: Renders only if title is provided */}
      {title && <h2 className="info-title">{title}</h2>}

      {/* 3. Dynamic Description: Renders only if description is provided */}
      {description && <p className="text-description">{description}</p>}

      {/* 4. Dynamic Bullet Points (already implemented correctly) */}
      {bulletPoints && bulletPoints.length > 0 && (
        <ul className="bullet-list">
          {bulletPoints
            // Filter first: Remove any items that are null, undefined, or just whitespace/empty strings
            .filter((point) => point && String(point).trim() !== "")
            // Map second: Only create list items for valid, non-empty points
            .map((point, index) => (
              <li key={index} className="bullet-item">
                {point}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}

export default TextBox;